import { render } from "./ContactNumberList.vue?vue&type=template&id=5317ae1c&scoped=true&ts=true"
import script from "./ContactNumberList.vue?vue&type=script&lang=ts"
export * from "./ContactNumberList.vue?vue&type=script&lang=ts"

import "./ContactNumberList.vue?vue&type=style&index=0&id=5317ae1c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5317ae1c"]])

export default __exports__